import { connect } from "react-redux";
import QueuesComponent from "../../../Components/DashboardComponent/Body/QueuesComponent";
const mapStateToProps = (state) => ({
    queues: state.reducer.queues,
});
const mapDispatchToProps = (dispatch) => ({
});
 
export default connect(mapStateToProps, mapDispatchToProps)(QueuesComponent);